(() => {
  if (window.toadShopCartReady) return;
  const tools = document.querySelector('[data-shop-cart-tools]');
  if (!tools) return;
  window.toadShopCartReady = true;
  const root = tools.dataset.rootUrl || '/';
  const key = 'toad:last-collection:v1';
  const pending = new WeakSet();
  const timers = new WeakMap();
  let memory = null;
  let countRequest = 0;
  const safeCollection = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/[^/]+)?\/?$/i.test(url.pathname)) return null;
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  };
  const readContext = () => {
    try { const saved = JSON.parse(sessionStorage.getItem(key)); if (saved && safeCollection(saved.url)) return saved; } catch (_) {}
    return memory;
  };
  const remember = (url, handle) => {
    const clean = safeCollection(url);
    if (!clean) return;
    memory = { url: clean, handle: handle || '' };
    try { sessionStorage.setItem(key, JSON.stringify(memory)); } catch (_) {}
  };
  const rememberCollection = () => {
    if (tools.dataset.pageType !== 'collection') return;
    const selected = document.querySelector('[data-category-link][aria-selected="true"]');
    remember(location.href, selected?.dataset.categoryLink || tools.dataset.collectionHandle);
  };
  const syncReturnLinks = () => {
    const context = readContext();
    const url = context?.url;
    if (url) document.querySelectorAll('[data-return-to-collection], toad-product .tp-back').forEach(link => { link.href = url; });
    // Carry the destination as well as saving it, for browsers that block storage.
    document.querySelectorAll('[data-shop-cart-link]').forEach(link => {
      const cart = new URL(tools.dataset.cartUrl, location.origin);
      if (url) cart.searchParams.set('toad_collection', url);
      link.href = cart.pathname + cart.search;
    });
  };
  const setupContext = () => {
    const incoming = new URL(location.href).searchParams.get('toad_collection');
    if (incoming && safeCollection(incoming)) remember(incoming, '');
    if (tools.dataset.pageType === 'collection') rememberCollection();
    if (tools.dataset.pageType === 'product' && tools.dataset.collectionUrl) {
      const saved = readContext();
      if (!saved || saved.handle !== tools.dataset.collectionHandle) remember(tools.dataset.collectionUrl, tools.dataset.collectionHandle);
    }
    syncReturnLinks();
  };
  const paintCount = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-shop-cart-count]').forEach(el => { el.textContent = String(count); });
    document.querySelectorAll('[data-shop-cart-link]').forEach(el => { el.setAttribute('aria-label', `View cart and checkout, ${count} ${count === 1 ? 'item' : 'items'}`); });
  };
  const refreshCount = async () => {
    const version = ++countRequest;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (version === countRequest) paintCount(cart.item_count);
      return cart;
    } catch (_) { return null; } // Keep the last confirmed count during connection failures.
  };
  const notifyOtherTabs = () => {
    try { localStorage.setItem('toad:cart-changed', String(Date.now())); } catch (_) {}
  };
  const resetButton = (form) => {
    clearTimeout(timers.get(form));
    if (pending.has(form)) return;
    const button = form.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-label]');
    if (!button || !label) return;
    let available = !button.disabled;
    const product = form.closest('toad-product');
    const picker = product?.querySelector('[data-variant-picker]');
    try {
      const variants = JSON.parse(product?.querySelector('[data-product-variants]')?.textContent || '[]');
      const selected = picker ? Array.from(picker.querySelectorAll('.tp-option')).map(field => field.querySelector('input:checked')?.value) : null;
      const variant = selected ? variants.find(item => item.options.every((option,index) => option === selected[index])) : variants.find(item => String(item.id) === form.querySelector('[name="id"]')?.value);
      if (variants.length && !variant) { button.disabled = true; label.textContent = 'Unavailable'; return; }
      if (variant) available = variant.available;
    } catch (_) {}
    button.disabled = !available;
    label.textContent = available ? (button.dataset.addLabelText || 'Add to cart') : (button.dataset.soldOutLabelText || 'Sold out');
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    const product = form.closest?.('toad-product');
    const button = form.querySelector?.('[data-add-to-cart]');
    if (!product || !button || !/\/cart\/add\/?$/.test(new URL(form.action, location.origin).pathname)) return;
    if (event.submitter && event.submitter !== button) return;
    event.preventDefault();
    if (pending.has(form) || button.disabled || !form.reportValidity()) return;
    const label = button.querySelector('[data-add-label]');
    const status = product.querySelector('[data-product-status]');
    const live = document.querySelector('[data-shop-cart-live]');
    const body = new FormData(form);
    body.delete('return_to');
    body.delete('checkout');
    clearTimeout(timers.get(form));
    pending.add(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (status) { status.hidden = true; status.textContent = ''; }
    let added = false;
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const error = new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check its availability.');
        error.cartResponse = true;
        throw error;
      }
      added = true;
      if (label) label.textContent = 'Item added';
      if (live) live.textContent = 'Item added to your cart.';
    } catch (error) {
      const message = error.cartResponse ? error.message : 'We could not confirm the update. Please check your cart before trying again.';
      if (status) { status.textContent = message; status.hidden = false; }
      if (live) live.textContent = message;
    } finally {
      // Shopify may partially add the available quantity even on an inventory error.
      await refreshCount();
      notifyOtherTabs();
      pending.delete(form);
      button.removeAttribute('aria-busy');
      resetButton(form);
      if (added && !button.disabled && form.querySelector('[name="id"]')?.value === body.get('id') && String(form.querySelector('[name="quantity"]')?.value || '1') === String(body.get('quantity') || '1')) {
        if (label) label.textContent = 'Item added';
        timers.set(form, setTimeout(() => { if (form.isConnected) resetButton(form); }, 3000));
      }
    }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('toad-product form');
    if (form && !pending.has(form)) resetButton(form);
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-category-link], [data-shop-cart-link], .toad-storefront__product, .collection-page .product-card')) {
      rememberCollection(); syncReturnLinks();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.target.closest('[data-category-link]')) { rememberCollection(); syncReturnLinks(); }
  });
  window.addEventListener('hashchange', () => { rememberCollection(); syncReturnLinks(); });
  window.addEventListener('pageshow', () => { setupContext(); refreshCount(); });
  window.addEventListener('focus', refreshCount);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCount(); });
  window.addEventListener('storage', event => { if (event.key === 'toad:cart-changed') refreshCount(); });
  document.addEventListener('shopify:section:load', () => { setupContext(); refreshCount(); });
  setupContext();
  refreshCount();
})();
